var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('b-spinner',{staticClass:"spinner mr-3",attrs:{"variant":"primary","label":"Large Spinner"}}),_c('strong',[_c('span',{staticClass:"text-primary loading-text"},[_vm._v(_vm._s(this.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }